/* Validate the approved inquiry fields, then leave posting and captcha to Shopify. */
(() => {
  const received = document.querySelector('[data-inquiry-received] h3');
  if (received) {
    received.focus();
    return;
  }

  const form = document.getElementById('wholesale-form');
  if (!form || form.tagName !== 'FORM') return;
  const errorSummary = document.getElementById('error-summary');
  const purposeGroup = document.getElementById('purpose-group');
  const purposeInputs = [...form.querySelectorAll('[name="contact[Order type]"]')];
  const requiredFields = [...form.querySelectorAll('input[required]:not([type="radio"])')];
  let attempted = false;

  function validateField(field) {
    const valid = field.value.trim().length > 0 && field.validity.valid;
    field.setAttribute('aria-invalid', String(!valid));
    document.getElementById(`${field.id}-error`).hidden = valid;
    return valid;
  }

  function validatePurpose() {
    const valid = purposeInputs.some(input => input.checked);
    purposeGroup.setAttribute('aria-invalid', String(!valid));
    document.getElementById('purpose-error').hidden = valid;
    purposeInputs.forEach(input => input.setAttribute('aria-invalid', String(!valid)));
    return valid;
  }

  function validateAll() {
    const invalid = [];
    if (!validatePurpose()) invalid.push(purposeInputs[0]);
    requiredFields.forEach(field => { if (!validateField(field)) invalid.push(field); });
    errorSummary.hidden = invalid.length === 0;
    errorSummary.textContent = invalid.length ? `Please complete ${invalid.length === 1 ? 'the highlighted field' : `the ${invalid.length} highlighted fields`} to send your inquiry.` : '';
    return invalid;
  }

  requiredFields.forEach(field => {
    field.addEventListener('blur', () => { if (field.value || attempted) validateField(field); });
    field.addEventListener('input', () => { if (attempted) validateAll(); });
  });
  purposeInputs.forEach(input => input.addEventListener('change', () => { if (attempted) validateAll(); }));

  form.addEventListener('submit', event => {
    attempted = true;
    const invalid = validateAll();
    if (invalid.length) {
      event.preventDefault();
      event.stopImmediatePropagation();
      invalid[0].focus();
    }
    // A valid event continues unchanged through Shopify's native contact/captcha flow.
    // Only Liquid form.posted_successfully? can render the received state.
  }, true);

  // Without JavaScript, native required/email validation and normal POST still work.
  form.noValidate = true;
  const serverErrors = document.getElementById('server-error-summary');
  if (serverErrors) serverErrors.focus();
})();
